import { mutationOptions } from '@tanstack/react-query'

import { api } from '../api/api'
import { type RequestApi } from '../api/types'
import { key } from './key'

type DeclineRequestParams =
  | { id: string; isDeclined: true }
  | { id: string; isDeclined: false; request: RequestApi.DeclineRequest }

export const declineRequestMutation = () =>
  mutationOptions({
    mutationKey: key('decline-request'),
    mutationFn: async (params: DeclineRequestParams) => {
      if (params.isDeclined) {
        await api.cancelDecline(params.id)

        return false
      }

      await api.decline(params.id, params.request)

      return true
    },
    retry: false,
  })
